import { defineComponent as _defineComponent } from 'vue'
import { Key } from '@/core/keycodes';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelfServiceConfirmationModal',
  props: {
    confirmText: null
  },
  setup(__props: any, { expose }) {



const openState = ref<boolean>(false);
let resolvePromise: Function;
let rejectPromise: Function;

expose({ confirm });

function confirm(): Promise<void> {
    document.addEventListener('keydown', onKeyDown);
    openState.value = true;

    return new Promise((resolve, reject) => {
        resolvePromise = resolve;
        rejectPromise = reject;
    });
}

function onKeyDown(event: KeyboardEvent): void {
    if (event.keyCode === Key.ENTER) {
        event.preventDefault();
        confirmed();
    }
    if (event.keyCode === Key.ESC) {
        denied();
    }
}

function confirmed(): void {
    resolvePromise(true);
    closeConfirmationModal();
}

function denied(): void {
    rejectPromise(false);
    closeConfirmationModal();
}

function closeConfirmationModal(): void {
    document.removeEventListener('keydown', onKeyDown);
    openState.value = false;
}

return { __sfc: true,openState, resolvePromise, rejectPromise, confirm, onKeyDown, confirmed, denied, closeConfirmationModal }
}

})